import React, { useState } from "react"
import TableColumnModal    from "./table_column_modal"

const EditTable = ({
  columns,
  currentTable,
  setCurrentTable,
}) => {
  if (!currentTable) return

  const [isOpen, setIsOpen] = useState(false)

  const confirmSelection = (selectedColumns, name) => {
    setIsOpen(false)

    requestAnimationFrame(() => {
      setCurrentTable(prev => ({
        ...prev,
        columns: selectedColumns,
        name
      }))
    })
  }

  return (
    <>
      <button
        className = "btn btn-primary small btn-sm ml-2 mr-2 no-print"
        onClick   = {() => setIsOpen(true)}
      >
        <i className = "fa fa-pencil" /> {I18n.t("button.edit")}
      </button>

      <TableColumnModal
        id              = "edit-table-modal"
        columns         = {columns}
        selectedColumns = {currentTable.columns}
        isOpen          = {isOpen}
        setIsOpen       = {setIsOpen}
        onConfirm       = {confirmSelection}
        title           = {I18n.t("export.edit_table")}
        confirmText     = {I18n.t("button.view")}
        tableTitle      = {currentTable.name}
      />
    </>
  )
}

export default EditTable
